import { render, staticRenderFns } from "./subject-overview-report.vue?vue&type=template&id=ddb1e698&scoped=true&"
import script from "./subject-overview-report.vue?vue&type=script&lang=js&"
export * from "./subject-overview-report.vue?vue&type=script&lang=js&"
import style0 from "./subject-overview-report.vue?vue&type=style&index=0&id=ddb1e698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb1e698",
  null
  
)

export default component.exports